<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="params.options.title"
    icon="res-report"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="detailData.id"
      :id="listId"
      :data="detailData"
      :getParams="getParams"
      :on-manager="onManager"
      :columns="columns"
      :exportDataOptions="params.options.exportDataOptions" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ReportList from './ReportList'

export default {
  name: 'ReportDataSidePage',
  components: {
    Actions,
    ReportList,
  },
  mixins: [SidePageMixin, WindowsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('report.report_detail'), key: 'report-list' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      return null
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'report-list':
          return 'ReportList'
        case 'event-drawer':
          return 'EventListForReportSettingSidePage'
        default:
          return ''
      }
    },
    columns () {
      return (this.params.options.columns || []).filter(item => item.field !== 'name')
    },
  },
  methods: {
  },
}
</script>
